import React, { useMemo, useState } from "react";
import { FiCheck } from "react-icons/fi";
import CollapsibleSection from "../CollapsibleSection";
import SectionSearch from "./SectionSearch";
import { filterOptions } from "./filterOptionUtils";
import styles from "../ViewOptionsPanel.module.scss";

const RadioSection = ({
  title,
  value,
  options = [],
  onChange,
  defaultOpen = true,
  searchPlaceholder = "Ara...",
}) => {
  const [query, setQuery] = useState("");
  const visibleOptions = useMemo(
    () => filterOptions(options, query),
    [options, query],
  );
  const showSearch = options.length > 0;

  return (
    <CollapsibleSection title={title} defaultOpen={defaultOpen}>
      <div className={styles.filterSectionBody}>
        {showSearch && (
          <SectionSearch
            value={query}
            onChange={setQuery}
            placeholder={searchPlaceholder}
            ariaLabel={`${title} ara`}
          />
        )}
        <div
          className={`${styles.radioList} ${styles.filterScrollList}`}
          role="radiogroup"
          aria-label={title}
        >
          {visibleOptions.map((opt) => {
            const selected = String(value ?? "") === String(opt.value ?? "");
            return (
              <button
                key={String(opt.value)}
                type="button"
                role="radio"
                aria-checked={selected}
                className={styles.radioItem}
                onClick={() => onChange?.(opt.value)}
              >
                <span
                  className={`${styles.radioCircle} ${selected ? styles.radioCircleActive : ""}`}
                >
                  {selected && <FiCheck size={9} />}
                </span>
                <span className={styles.pickerItemLabel}>{opt.label}</span>
              </button>
            );
          })}
          {query.trim() && visibleOptions.length === 0 && (
            <div className={styles.pickerHint}>Sonuç bulunamadı</div>
          )}
        </div>
      </div>
    </CollapsibleSection>
  );
};

export default RadioSection;
